/**
 * Textos (`ca`) del vocabulari NEUTRE dels estats d'un lot (OBR-14): el que diuen igual el BackOffice, planta i la consola.
 * Namespace `domain.stockStates`; les claus les troba `stockStateReason`, `stockBlockReasonKey` i `stockLotStateKey` de
 * `domain/stockStates.ts`. Namespace `backoffice.stockErrors`: els errors de les RPC d'Existències que la pantalla no
 * pot evitar amb la seva pròpia validació (les altres són a `backoffice.stockLine`). Tall propi: no es toca `ca.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const statesCa = {
  'domain.stockStates': {
    // L'estat d'un lot en un lloc. «Caduca aviat» és un destacat d'un lot Disponible, no un estat.
    state_available: 'Disponible',
    state_blocked: 'Bloquejat',
    state_expired: 'Caducat',
    state_soon: 'Caduca aviat',
    stateBlockedLong: 'Bloquejat / Quarantena',

    // Per què un lot no es pot consumir: tots els motius que té.
    blockReason_expired: 'Caducat',
    blockReason_manual: 'Bloquejat a mà',
    blockReason_return: 'Devolució pendent de sortir',
    blockReason_exception: 'Excepció de recepció pendent de decisió',

    // Què implica l'estat (matriu de la decisió D6).
    reasonConsumeBlocked: 'Bloquejat: no es pot consumir ni expedir.',
    reasonConsumeExpired: 'Caducat: no es pot consumir ni expedir.',
    reasonMoveWarning:
      'Aquest lot no és disponible. El pots moure, però no es pot consumir ni expedir fins que torni a estar disponible. Si és un bloqueig a mà, el lloc de destí també queda bloquejat: la quarantena segueix la mercaderia.',
    reasonAdjustExpired: 'El lot ha caducat: el motiu recomanat és «Caducat».',
  },

  'backoffice.stockErrors': {
    badQuantity: 'La quantitat ha de ser diferent de zero.',
    badReason: 'Tria un motiu de la llista.',
    noteRequired: 'Cal escriure el motiu de l’ajust.',
    twoLots: 'Un moviment pertany a un sol lot: tria’n només un.',
    unknownArticle: 'Aquest article no existeix en aquest obrador.',
    untracked: 'Aquest article no té control d’existències.',
    unknownLot: 'Aquest lot no existeix o no és d’aquest article.',
    clientUuidConflict: 'Aquesta operació ja correspon a un altre moviment. Torna a obrir el diàleg i prova-ho de nou.',
    stateBadState: 'Aquest estat no es pot triar: només Disponible o Bloquejat.',
    stateLotRequired: 'Cal triar un lot (només un) per canviar-ne l’estat.',
  },
} as const;
